import script from "./ToolTipButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToolTipButton.vue?vue&type=script&lang=ts&setup=true"

import "./ToolTipButton.vue?vue&type=style&index=0&id=35881e7c&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35881e7c"]])

export default __exports__